<template>
  <section class="is--slider-blog container-full">
    <div class="background">
      <div class="container">
        <h2 class="section-head">
          <img
            v-lazy="'/assets/logo/logo-zaun24-ratgeber.svg'"
            alt="Zaun24 | Ratgeber"
            width="245px"
            height="40px"
          >
        </h2>

        <div class="blog-wrap">
          <post-tile v-if="featuredPost" :key="featuredPost.id" :post="featuredPost" />
          <post-tile v-for="(post) in postList.slice(0,3)" :key="post.id" :post="post" />
        </div>

        <div class="blog-actions">
          <router-link :to="localizedRoute('/posts')" class="btn btn-primary">
            Mehr entdecken
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { registerModule } from '@vue-storefront/core/lib/modules'
import PostsIndex from '../../../posts/Index'

async function ensureWordpressModule (store) {
  if (!store.state.wordpress) {
    const { Wordpress } = await import(
      /* webpackChunkName: "vsf-wordpress-module" */ 'src/modules/wordpress/storefront-module'
    )
    registerModule(Wordpress)
  }
}

export default {
  mixins: [PostsIndex],
  serverPrefetch () {
    return Promise.resolve()
  },
  async mounted () {
    if (!Array.isArray(this.posts) || !this.posts.length) {
      await ensureWordpressModule(this.$store)
      this.fetchPosts()
    }
  }
}
</script>
